module.exports = __webpack_public_path__ + "img/banner_upon_1242x782_nou.e7db6bf2.jpg";